import { getEnumClientPaymentStatusName } from '../autogen/bundle';

export const CLIENT_PAYMENT_STATUS_COMPLETE = 0;
export const CLIENT_PAYMENT_STATUS_PENDING  = 1;

export const CLIENT_PAYMENT_RESULT_OK                      =  0;
export const CLIENT_PAYMENT_RESULT_CANCELLED               =  1;
export const CLIENT_PAYMENT_RESULT_ERR_INET                =  2; // internet connection error
export const CLIENT_PAYMENT_RESULT_ERR_NOT_READY           =  3; // billing is not ready yet
export const CLIENT_PAYMENT_RESULT_ERR_BUSY                =  4; // billing system is busy
export const CLIENT_PAYMENT_RESULT_ERR_VERIFY              =  5; // billing verification error
export const CLIENT_PAYMENT_RESULT_ERR_SYSTEM              =  6; // unexpected platform error
export const CLIENT_PAYMENT_RESULT_ERR_DISABLED            =  7; // billing disabled in device settings
export const CLIENT_PAYMENT_RESULT_ERR_DECLINED            =  8; // payment declined by processing (e.g. not enough money)
export const CLIENT_PAYMENT_RESULT_ERR_ALREADY_PURCHASED   =  9; // purchased was already marked as complete 
export const CLIENT_PAYMENT_RESULT_ERR_UNAVAILABLE         = 10; // product is unavailable for purchase in store
export const CLIENT_PAYMENT_RESULT_ERR_UNKNOWN             = 11; // purchase was seemingly ok but something really weird happened
export const CLIENT_PAYMENT_RESULT_ERR_SERVER_INTERNAL     = 12; // RPC processing went wrong - alert devs and retry later
export const CLIENT_PAYMENT_RESULT_ERR_SERVER_INCOMPATIBLE = 13; // Server sent something that client couldn't read - should update the game?
export const CLIENT_PAYMENT_RESULT_ERR_UNSUPPORTED_BUILD   = 14; // developer explicitly disabled payments (e.g. in beta-builds)

export function getEnumClientPaymentStatusNameFormatted(code) {
  return getEnumClientPaymentStatusName(code).toLowerCase();
}

export function isClientPaymentSuccessful(clientPayment) {
  return clientPayment.status === CLIENT_PAYMENT_STATUS_COMPLETE && clientPayment.result === CLIENT_PAYMENT_RESULT_OK;
}

export function isClientPaymentFail(clientPayment) {
  return clientPayment.status === CLIENT_PAYMENT_STATUS_COMPLETE && clientPayment.result !== CLIENT_PAYMENT_RESULT_OK;
}

export function getClientPaymentFailDescription(result) {
  switch(result) {
    case CLIENT_PAYMENT_RESULT_ERR_INET:                return 'internet connection error';
    case CLIENT_PAYMENT_RESULT_ERR_NOT_READY:           return 'billing is not ready yet';
    case CLIENT_PAYMENT_RESULT_ERR_BUSY:                return 'billing system is busy';
    case CLIENT_PAYMENT_RESULT_ERR_VERIFY:              return 'billing verification error';
    case CLIENT_PAYMENT_RESULT_ERR_SYSTEM:              return 'unexpected platform error';
    case CLIENT_PAYMENT_RESULT_ERR_DISABLED:            return 'billing disabled in device settings';
    case CLIENT_PAYMENT_RESULT_ERR_DECLINED:            return 'payment declined by processing (e.g. not enough money)';
    case CLIENT_PAYMENT_RESULT_ERR_ALREADY_PURCHASED:   return 'purchased was already marked as complete';
    case CLIENT_PAYMENT_RESULT_ERR_UNAVAILABLE:         return 'product is unavailable for purchase in store';
    case CLIENT_PAYMENT_RESULT_ERR_UNKNOWN:             return 'purchase was seemingly ok but something really weird happened';
    case CLIENT_PAYMENT_RESULT_ERR_SERVER_INTERNAL:     return 'RPC processing went wrong - alert devs and retry later';
    case CLIENT_PAYMENT_RESULT_ERR_SERVER_INCOMPATIBLE: return 'Server sent something that client couldn\'t read - should update the game?';
    case CLIENT_PAYMENT_RESULT_ERR_UNSUPPORTED_BUILD:   return 'developer explicitly disabled payments (e.g. in beta-builds)';
  }
  return null;
}

export function getQAUserRoleName(role) {
  switch(role) {
    case 1: return 'player';
    case 2: return 'QA user';
  }
  return '?';
}
